$(document).on('turbolinks:load', function() {

  if($('.district-metrics').length) {

    $('#participation_school_select').on('change', function() {
      const school_id = $(this).val();
      $('.pie_progress.school-progress').hide();
      $('.pie_progress.school-progress[data-school-id="' + school_id + '"]').show();
    });

    $('#pie_chart_school_select').on('change', function() {
      let url = `/districts/${$('.district-metrics').data('district-id')}/campaigns/${$('.district-metrics').data('campaign-id')}/metrics_pie_chart.js`
      if($(this).val()) {
        url += '?school_id=' + $(this).val()
      }

      $.ajax({
        url: url,
        type: 'GET',
        success: function (result) {
          eval(result);
        }
      });
    });

    $('#averages_school_select').on('change', function() {
      $('.campaign-averages').addClass('stats-container__hidden');
      const school_id = $(this).val() ? $(this).val() : false;
      $('.campaign-averages[data-school-id="' + school_id + '"]').removeClass('stats-container__hidden');
    });
  }
  if($('.district-metrics').length) {
    if(!$('.district-metrics .pie_progress svg').length) {
      $('.district-metrics .pie_progress').each(function() {
        let $pie = $(this);
        $(this).asPieProgress({
          namespace: 'pie_progress',
          size: 216,
          barsize: 48,
          trackcolor: '#EAECEE',
          numberCallback: function(n) {
            if($pie.data('max') == "0") {
              $pie.find('.pie_progress__number').text('0%');
            } else {
              var percentage = this.getPercentage(n);
              $pie.find('.pie_progress__number').text(percentage + '%');
            }
          }
        });
      });

      $('.district-metrics .pie_progress').asPieProgress('finish');
    }
  }
  $('.district-page-content').on('click', '.student-metrics-table th.sortable-heading div.sorteable-container', function(e) {
    let $th = $(this).parent(),
      field = $th.data('field'),
      dir;

    if($th.hasClass('sort') || $th.hasClass('sort_desc')) {
      dir = 'asc'
    }
    else {
      dir = 'desc'
    }

    $('#sort').val(field);
    $('#sort_dir').val(dir);
    $(this).closest('form').find('input[type="submit"]').trigger('click');
  });
  
  if ($("#pagination-content").length) {
    setTimeout(function() {
      var navElement = document.querySelector('#pagination-content');
      var linkElements = navElement.querySelectorAll('a');
      var currentUrl = window.location.href;
      linkElements.forEach(function(linkElement) {
        href = linkElement.href
        var queryParameter = href.split('?')[1];
        linkElement.href = currentUrl.split('?')[0]+'?'+queryParameter;
      });
    }, 1000);
  }

  $('.district-page-content').on('click', '.student-metrics-table-download-csv', function(e) {
    e.preventDefault();
    $('.student-metrics-table-csv-copy').submit();
  });

  $('.invitation-override-trigger').on('click', function(e) {
    e.preventDefault();
    $(this).closest('.invitation-count-form-container').toggleClass('open');
  });

  $('.district-page-content').on('click', '.start-end svg', function(e) {
    $(this).parent().find('.kick-off-date-section').removeClass('hidden');
  });

  $('.district-page-content').on('click', '.kick-off-date-section .cancel-edit', function(e) {
    $(this).closest('.kick-off-date-section').addClass('hidden');
  });

  $('#new_campaign_cancel').click(function() {
    window.history.back();
  });

  function adjustProgressPin(){
    setTimeout(function() {
        if ( $(".progress-container-metrics").length > 0 ) {
          lowerOffset1 = $(".progress-container-metrics").offset().top
          lowerOffset = $(".goal-metrics").offset().top
          $(".progress-pin").css('top', -40)
        }
    }, 100);
  }

  $(document).ready(adjustProgressPin);
  $(window).resize(adjustProgressPin);

  // Update the countdown clock every second
  setInterval(function() {
    const startDate = new Date($('#start-date-countdown').val()).getTime();
    const endDate = new Date($('#end-date-countdown').val()).getTime();
    const nowLocal = new Date();
    const now = new Date(Date.UTC(nowLocal.getUTCFullYear(), nowLocal.getUTCMonth(), nowLocal.getUTCDate(), 
                          nowLocal.getUTCHours(), nowLocal.getUTCMinutes(), nowLocal.getUTCSeconds())); // convert to UTC

    // Calculate the time remaining based on whether start date is before or after today
    let timeRemaining;
    var counterElement = document.getElementById("remaining-countdown");
    if (counterElement != null) {
      if (startDate <= now) {
        timeRemaining = endDate - now;
        counterElement.innerHTML = "Remaining Time";
      } else {
        timeRemaining = startDate - now;
        counterElement.innerHTML = "Kicking Off In";
      }

      // Calculate the days, hours, minutes, and seconds remaining
      const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

      // Update the HTML with the remaining time
      document.getElementById("countdown-clock-days").innerHTML = days;
      document.getElementById("countdown-clock-hours").innerHTML = hours;
      document.getElementById("countdown-clock-min").innerHTML = minutes;
      document.getElementById("countdown-clock-sec").innerHTML = seconds;
    }
  }, 1000);
});
